import React from "react";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

const RequestBuilder = ({ requestJson }) => {

    const requestBody = (requestJson && JSON.stringify(requestJson.requestBody, null, 2)) ?? "Request Body will display here for the relavant transaction request."

    return (
        <div>
            <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="body-tab" data-bs-toggle="tab" data-bs-target="#body" type="button" role="tab" aria-controls="body" aria-selected="false">Body</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link" id="params-tab" data-bs-toggle="tab" data-bs-target="#params" type="button" role="tab" aria-controls="params" aria-selected="true">Params</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link" id="headers-tab" data-bs-toggle="tab" data-bs-target="#headers" type="button" role="tab" aria-controls="headers" aria-selected="false">Headers</button>
                </li>
            </ul>
            <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="body" role="tabpanel" aria-labelledby="body-tab" style={{ padding: "20px 10px" }}>
                    <div className="docs-code-block">
                        <pre className="shadow-lg rounded"><code className="language-dockerfile hljs" style={{ overflowX: "hidden" }}>
                            <div className="row code-header">
                                <div className="col-md-10 languages">

                                </div>
                                <div className="col-md-2">

                                </div>
                            </div>
                            <div>
                                <SyntaxHighlighter language="json" style={dracula} showLineNumbers={false}>
                                    {requestBody}
                                </SyntaxHighlighter>
                            </div>
                        </code></pre>
                    </div>

                </div>
                <div className="tab-pane fade" id="params" role="tabpanel" aria-labelledby="params-tab">
                    <div className="docs-code-block">
                        <pre className="shadow-lg rounded">
                            <code className="language-dockerfile hljs" style={{ color: "white" }}>
                                <table style={{ marginTop: "5px" }}>
                                    <tbody>
                                        
                                        {requestJson?.params?.length > 0 ? requestJson?.params.map((item, index) =>
                                            <tr>
                                                <td>{item.key}</td>
                                                <td>:{item.value}</td>
                                            </tr>
                                        ) : <span style={{ color: "orange" }}>NO PARAMETERS</span>}
                                    </tbody>
                                </table>
                            </code>
                        </pre>
                    </div>
                </div>
                <div className="tab-pane fade" id="headers" role="tabpanel" aria-labelledby="headers-tab">
                    <div className="docs-code-block">
                        <pre className="shadow-lg rounded">
                            <code className="language-dockerfile hljs" style={{ color: "white" }}>
                                <table style={{ marginTop: "5px" }}>
                                    <tbody>
                                        {requestJson?.headers?.length > 0 ? requestJson?.headers.map((item, index) =>
                                            <tr>
                                                <td>{item.key}</td>
                                                <td>:{item.value}</td>
                                            </tr>
                                        )  : <span style={{ color: "orange" }}>NO HEADERS</span>}
                                    </tbody>
                                </table>
                            </code>
                        </pre>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RequestBuilder;